import isEmpty from "lodash/isEmpty";
import { MatchCard } from "PFApp/components/activity_match_card";
import { Stack } from "PFComponents/containers";
import { LoadingDots } from "PFComponents/loading_dots";
import { useActivityRankedShortlists } from "PFCore/hooks/queries/shortlists/use_activity_ranked_shortlists";
import { useActivityShortlists } from "PFCore/hooks/queries/shortlists/use_activity_shortlists";
import { useActivitySuspendedShortlists } from "PFCore/hooks/queries/shortlists/use_activity_suspended_shortlists";
import { useIsUnbiasedMode } from "PFCore/hooks/use_is_unbiased_mode";
import { Shortlist } from "PFTypes";

import { useBookingActivityContext } from "../../../providers/booking_activity_context_provider";

export const ShortlistItems = () => {
  const { id, activity } = useBookingActivityContext();
  const isUnbiasedMode = useIsUnbiasedMode(activity?.reviewers);
  const hasOpenVacancy = !!activity?.vacancies && activity.vacancies.total - activity.vacancies.closed > 0;

  const { data: shortlists, isFetching: isShortlistsFetching } = useActivityShortlists(id!);
  const { data: suspendedShortlists, isFetching: isSuspendedShortlistsFetching } =
    useActivitySuspendedShortlists(id!);
  const allShortlists = [
    ...(shortlists?.entries || []),
    ...(suspendedShortlists?.entries || [])
  ] as Shortlist[];

  const { data: rankedShortlists, isFetching: isRankedShortlistsFetching } = useActivityRankedShortlists({
    activityId: id!
  });

  const isLoading = isShortlistsFetching || isSuspendedShortlistsFetching || isRankedShortlistsFetching;

  return !isEmpty(allShortlists) && !!activity ? (
    <Stack>
      {allShortlists.map((shortlist) => {
        const match = (rankedShortlists?.entries || []).find((it) => it.profile.id === shortlist.profile.id);
        return (
          <MatchCard
            key={shortlist.id}
            match={match}
            shortlist={shortlist}
            role={activity}
            isUnbiasedMode={isUnbiasedMode}
            isFillDisabled={!hasOpenVacancy}
            areButtonsDisabled={isLoading}
            isCompressed
          />
        );
      })}
    </Stack>
  ) : (
    <LoadingDots circlesEnabled pageViewEnabled />
  );
};
